import { usersSearchEnabled } from '@/actions-permission/users.permissions'
import { invitesSearchEnabled } from '@/actions-permission/invites.permissions'
import { actionsLogSearchEnabled } from '@/actions-permission/action-log.permissions'

const TEAM = ({ permissionIsEnabled, routeName }) => {
  return {
    key: 'team',
    label: 'sidemenu.team',
    showSection:
      usersSearchEnabled(permissionIsEnabled) ||
      invitesSearchEnabled(permissionIsEnabled) ||
      actionsLogSearchEnabled(permissionIsEnabled),
    items: {
      users: {
        label: 'sidemenu.submenu.team.users',
        showItem: usersSearchEnabled(permissionIsEnabled),
        active: routeName === 'users' || routeName === 'usersDetail'
      },
      invites: {
        label: 'sidemenu.submenu.team.invites',
        showItem: invitesSearchEnabled(permissionIsEnabled),
        active:
          routeName === 'invites' ||
          routeName === 'invitesDetail' ||
          routeName === 'invites-create'
      },
      logs: {
        label: 'sidemenu.submenu.team.logs',
        showItem: actionsLogSearchEnabled(permissionIsEnabled),
        active: routeName === 'logs'
      }
    }
  }
}

export default TEAM
